import { useState } from 'react'

import './_paymentMethod.scss'
import { useTranslation } from 'react-i18next'
import { useMutation } from 'react-query'

import {
    IconClockOutline,
    IconDollarCircleArrowsOutline,
    IconWalletOutline
} from 'assets/svg/sprite'
import InfoDiv from 'components/UI/InfoDiv/InfoDiv'
import { ActionCard } from 'components-ref/molecules/ActionCard/ActionCard'
import { Icons } from 'helpers/icons'
import { deleteBankInformation } from 'services/endpoints/settings/general/payout'
import { useAuthStore, useUserProfile } from 'store'
import ConfirmModal from 'components/UI/Modal/Confirm/ConfirmModal'
import { Modal } from 'components-ref/molecules/modal/modal'

export const Wire = () => {
    const { t } = useTranslation()
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false)
    const userData = useUserProfile()!

    const hasBankAccount = Boolean(userData?.bank_acct_last3)

const deleteAccountInfo = useMutation(deleteBankInformation, {
    onSuccess: () => {
        useAuthStore.getState().setUserProfile({
            bank_acct_last3: null,
            payout_method: null
        })

        setShowDeleteConfirm(false)
    }
})

    return (
        <>
            {hasBankAccount ? (
                <ActionCard
                    icon={Icons.payments}
                    iconSize='big'
                    text='Account Details'
                    subtext={
                        <div>
                            <div>
                                <span>
                                    {`${t('account')} # `}
                                    <span className='paymentMethod__actionCard__account'>
                                        {`****${userData.bank_acct_last3}`}
                                    </span>
                                </span>
                            </div>
                        </div>
                    }
                    // hasArrow
                    // link='/settings/general/payout-settings/payment-method/wire/bank-information'
                    trashFn={() => setShowDeleteConfirm(true)}
                />
            ) : (
                <ActionCard
                    link='/settings/general/payout-settings/payment-method/wire/bank-information'
                    icon={Icons.payment_plus}
                    iconSize='big'
                    text={t('addBankAccount')}
                    addNewText
                />
            )}

            <div className='paymentMethod__info'>
                <InfoDiv
                    icon={<IconWalletOutline width='24' height='24' />}
                    title={t('settings:MinimumWithdrawal')}
                    boldText={
                        userData?.payout_method === 'wire'
                            ? '$50.00'
                            : '$20.00'
                    }
                />

                <InfoDiv
                    icon={<IconClockOutline />}
                    title={t('settings:ProcessingTime')}
                    boldText='3-5'
                    plainText={t('settings:BuisnessDays')}
                />

                <InfoDiv
                    icon={
                        <IconDollarCircleArrowsOutline
                            color='black'
                            width='26'
                            height='26'
                        />
                    }
                    title={t('settings:OtherFeatures')}
                    boldText={t('settings:NoLimits')}
                    plainText={t('settings:onDailyWithdrawals')}
                />
            </div>
            {showDeleteConfirm && (
                <Modal
                    onClose={() => setShowDeleteConfirm(false)}
                    closeOnLayerClick={!deleteAccountInfo.isLoading}
                    maxWidth={40}
                    isLayerTransparent={false}
                    title='Remove Bank Account'
                    paddingBottom={0}
                    hideCloseIcon={true}
                >
                    <ConfirmModal
                        confirmButtonWidth='14'
                        body={
                            <>
                                Are you sure you want to remove your bank account?
                                <br />
                                <br />
                                You will need to add new banking information
                                before receiving future payouts.
                            </>
                        }
                        confirmText='Remove'
                        confirmFn={() => {
                            if (!deleteAccountInfo.isLoading) {
                                deleteAccountInfo.mutate()
                            }
                        }}
                        onCancel={() => setShowDeleteConfirm(false)}
                    />
                </Modal>
            )}
        </>
    )
}